import React from "react";
import { Container, Row } from "react-bootstrap";
import Slider from "react-slick";
import { ImageUrl } from "../../../../../Helpers/request";
import { LazyLoadImage } from "react-lazy-load-image-component";
const TestimonialMacau = () => {
  var settings = {
    dots: true,
    infinite: true,
    arrows: true,
    speed: 500,
    accessibility: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  return (
    <section
      className="py-5 noBgImage ptMob30 pbMob30"
      style={{
        backgroundImage:
          "url(" + ImageUrl + "theme/macau/testimonial_bg.jpg" + ")",  }}
    >
      <Container className="py-lg-5">
        <div className="text-center mx-auto mb-5">
          <h3 className="title_heading mb-0 pb-0 d-block text-uppercase fontMessiri">
            Testimonials
          </h3>
        </div>

        <Slider {...settings} className="overflow-hidden shapeBySl ">
          {Array(5)
            .fill()
            .map((val, index) => (
              <div key={index} className="text-center mb-4 col-lg-6">
                <div className="imgWrapper1">
                  <LazyLoadImage
                    className="img-fluid rounded-circle"
                    src={
                      `${ImageUrl}theme/macau/testi-2.webp`
                    }
                    alt=""
                  />
                </div>
                <h3 className="RingSettingTitleSPL fontMessiri mt-2">
                  DESTINEE
                </h3>
                <p className="colorGrey fontMessiri mb-2">Marketing Personal</p>
                <p className="fontMessiri mb-2">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever.
                </p>
                <a className="text-dark fontMessiri" href="/">
                  Read more...
                </a>
              </div>
            ))}
        </Slider>
      </Container>
    </section>
  );
};

export default TestimonialMacau;
